import { getLocalStorageData } from '../../utils/helper';
import { APP_API_URL_V2 } from '../../utils/xhr-instance';
import { axiosInstanceV2 } from '../axios';

export async function createCustomer(formData) {
	const API_URL = `${APP_API_URL_V2}/customer`;
	const token = getLocalStorageData();
	return await axiosInstanceV2
		.post(API_URL, formData, {
			headers: {
				'Content-Type': 'multipart/form-data',
				Authorization: `Bearer ${token?.token}`,
			},
		})
		.then((res) => {
			return res.data;
		})
		.catch((err) => {
			return err?.response?.data.message;
		});
}

export async function updateCustomer(data, id) {
	const API_URL = `${APP_API_URL_V2}/customer/${id}`;
	const token = getLocalStorageData();

	return await axiosInstanceV2
		.put(API_URL, data, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		})
		.then((res) => res.data)
		.catch((err) => err?.response?.data?.message || 'Something went wrong');
}

export async function deleteCustomer(data) {
	const API_URL = `${APP_API_URL_V2}/customer`;
	const token = getLocalStorageData();
	try {
		await axiosInstanceV2.delete(API_URL, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
			data: data,
		});
	} catch (error) {
		throw error;
	}
}
export async function deleteCustomerDocuments(customerId, documentId) {
	const API_URL = `${APP_API_URL_V2}/customer/${customerId}/documents/${documentId}`;
	const token = getLocalStorageData();
	try {
		await axiosInstanceV2.delete(API_URL, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		});
	} catch (error) {
		throw error;
	}
}
export async function changeCustomerStatus(data) {
	const API_URL = `${APP_API_URL_V2}/customer/status`;
	const token = getLocalStorageData();
	try {
		await axiosInstanceV2.patch(API_URL, data, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		});
	} catch (error) {
		throw error;
	}
}

export async function getCustomerDetail(id) {
	const token = getLocalStorageData();
	try {
		const res = await axiosInstanceV2.get(`${APP_API_URL_V2}/customer/${id}`, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		});
		return res.data.data;
	} catch (error) {
		throw error?.response?.data?.message;
	}
}
export async function getCustomerList(data) {
	const token = getLocalStorageData();
	try {
		const res = await axiosInstanceV2.post(`${APP_API_URL_V2}/customer/list`, data, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		});
		return res.data.data;
	} catch (error) {
		throw error?.response?.data?.message;
	}
}
